/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSlipVerificationSlipResponse } from '../models/GetSlipVerificationSlipResponse';
import type { JsonNode } from '../models/JsonNode';
import type { PaginatedSlipVerificationDto } from '../models/PaginatedSlipVerificationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SlipVerificationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public retrySlip({
        id,
    }: {
        id: string,
    }): CancelablePromise<JsonNode> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/slip-verifications/{id}/retry',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedSlipVerificationDto OK
     * @throws ApiError
     */
    public searchShopVerifications({
        shopId,
        search = '',
        sortBy = '',
        direction = '',
        from = '',
        to = '',
        page,
        limit = 20,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        direction?: string,
        from?: string,
        to?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedSlipVerificationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/slip-verifications/{shopId}/search',
            path: {
                'shopId': shopId,
            },
            query: {
                'search': search,
                'sortBy': sortBy,
                'direction': direction,
                'from': from,
                'to': to,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetSlipVerificationSlipResponse OK
     * @throws ApiError
     */
    public getSlipVerificationImage({
        slipVerificationId,
    }: {
        slipVerificationId: string,
    }): CancelablePromise<GetSlipVerificationSlipResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/slip-verifications/slip/{slipVerificationId}',
            path: {
                'slipVerificationId': slipVerificationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
